<template>
    <div class="page-profile__header">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="profile-heading__user profile-heading__user-organization d-flex">

                        <div class="profile-heading__user-header">
                            <div class="profile-heading__user-image">
                                <img :src="`/storage${getterOrganization.avatar.path.replace('original', 'avatar')}`"
                                     :alt="getterOrganization.owner.name" v-if="getterOrganization.avatar">
                                <span v-text="getUserPM(getterOrganization.name)"></span>
                            </div>
                            <span class="profile-heading__user--verified-icon">
                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.9363 23.9159L9.82825 24.7678C8.22178 25.4171 6.39141 24.6589 5.71454 23.0639L4.82634 20.9709C4.67399 20.6118 4.38816 20.326 4.02914 20.1737L1.93611 19.2855C0.341093 18.6086 -0.417071 16.7782 0.232162 15.1718L1.0841 13.0637C1.23024 12.7021 1.23024 12.2979 1.0841 11.9363L0.232162 9.82825C-0.417071 8.22178 0.341093 6.39141 1.93611 5.71454L4.02914 4.82634C4.38816 4.67399 4.67399 4.38816 4.82634 4.02914L5.71454 1.93611C6.39141 0.341093 8.22178 -0.417071 9.82825 0.232162L11.9363 1.0841C12.2979 1.23024 12.7021 1.23024 13.0637 1.0841L15.1718 0.232162C16.7782 -0.417071 18.6086 0.341093 19.2855 1.93611L20.1737 4.02914C20.326 4.38816 20.6118 4.67399 20.9709 4.82634L23.0639 5.71454C24.6589 6.39141 25.4171 8.22178 24.7678 9.82825L23.9159 11.9363C23.7698 12.2979 23.7698 12.7021 23.9159 13.0637L24.7678 15.1718C25.4171 16.7782 24.6589 18.6086 23.0639 19.2855L20.9709 20.1737C20.6118 20.326 20.326 20.6118 20.1737 20.9709L19.2855 23.0639C18.6086 24.6589 16.7782 25.4171 15.1718 24.7678L13.0637 23.9159C12.7021 23.7698 12.2979 23.7698 11.9363 23.9159Z" fill="#F6C143"/>
                                    <path d="M9.325 11.25H8.3C8.27239 11.25 8.25 11.2724 8.25 11.3V15.95C8.25 15.9776 8.27239 16 8.3 16H9.325C9.35261 16 9.375 15.9776 9.375 15.95V11.3C9.375 11.2724 9.35261 11.25 9.325 11.25Z" fill="#F6C143" stroke="white" stroke-width="0.5"/>
                                    <path d="M11.8289 11.25H10.8039C10.7763 11.25 10.7539 11.2724 10.7539 11.3V15.95C10.7539 15.9776 10.7763 16 10.8039 16H11.8289C11.8565 16 11.8789 15.9776 11.8789 15.95V11.3C11.8789 11.2724 11.8565 11.25 11.8289 11.25Z" fill="#F6C143" stroke="white" stroke-width="0.5"/>
                                    <path d="M6.875 17.05V18.075C6.875 18.1026 6.89739 18.125 6.925 18.125H18.075C18.1026 18.125 18.125 18.1026 18.125 18.075V17.05C18.125 17.0224 18.1026 17 18.075 17H6.925C6.89739 17 6.875 17.0224 6.875 17.05Z" fill="#F6C143" stroke="white" stroke-width="0.5"/>
                                    <path d="M17.9353 10.0625H7.06465C7.01328 10.0625 6.99531 9.99431 7.04 9.96899L12.4753 6.88896C12.4906 6.88029 12.5094 6.88029 12.5246 6.88896L17.96 9.96899C18.0047 9.99431 17.9867 10.0625 17.9353 10.0625Z" fill="#F6C143" stroke="white" stroke-width="0.5"/>
                                    <path d="M16.827 11.25H15.802C15.7743 11.25 15.752 11.2724 15.752 11.3V15.95C15.752 15.9776 15.7743 16 15.802 16H16.827C16.8546 16 16.877 15.9776 16.877 15.95V11.3C16.877 11.2724 16.8546 11.25 16.827 11.25Z" fill="#F6C143" stroke="white" stroke-width="0.5"/>
                                    <path d="M14.325 11.25H13.3C13.2724 11.25 13.25 11.2724 13.25 11.3V15.95C13.25 15.9776 13.2724 16 13.3 16H14.325C14.3526 16 14.375 15.9776 14.375 15.95V11.3C14.375 11.2724 14.3526 11.25 14.325 11.25Z" fill="#F6C143" stroke="white" stroke-width="0.5"/>
                                </svg>

                            </span>
                        </div>

                        <div class="profile-heading__user-info">

                            <div class="profile-heading__user-info-heading d-flex">
                                <div class="profile-heading__user-info-name">
                                    {{getterOrganization.name}}
                                </div>
                            </div>

                            <div class="profile-heading__user-pets d-flex">
                                <div class="profile-heading__user-pets-item profile-heading__user-pets-item--full"
                                     v-if="getterOrganization['entry_link'] && getterOrganization && getterOrganization.owner && getUserData && getterOrganization.owner.id === getUserData.id">
                                    {{getterOrganization['entry_link']}}
                                </div>
                                <div class="profile-heading__user-pets-item profile-heading__user-pets-actual">
                                    {{getterOrganizationStats.supported_projects_count || 0}} проектов поддержано
                                </div>
                                <div class="profile-heading__user-pets-item profile-heading__user-pets-arranged">
                                    {{ getterOrganizationStats.supported_active_projects_count || 0 }} проектов в реализации
                                </div>
                                <div class="profile-heading__user-pets-item profile-heading__user-pets-ads">
                                    {{ getterOrganizationStats.supported_active_pets_count || 0 }} животных на попечении
                                </div>
                            </div>

                            <div class="profile-heading__user-donations">
                                Средств отправлено:
                                <span class="profile-heading__user-donations-sum">{{getterOrganizationStats['donated_total']}} BYN</span>
                            </div>
                        </div>



                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
    name: "OrganizationHeading",
    props: ['data'],

    mounted(){
        if(this.data && this.data.id) this.getOrganization({idx: this.data.id, stats: true})
    },


    computed:{
        ...mapGetters(['getterOrganization','getterOrganizationStats', 'getUserData']),
    },

    methods:{

        ...mapActions(['getOrganization']),

        getUserPM(name){
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
    },

}
</script>

<style scoped>

</style>
